import Model from '@/Models/Model'

export default class AffiliateCompany extends Model {
  /**
   * Resource
   *
   * @returns {string}
   */
  resource() {
    return 'affiliate-sa/companies'
  }
}
